/**
 *
 * @component /进度详情/ 工期调整 弹窗
 **/

import BaseModal from '&/components/BaseModal';
import { Button, Space, Form, Input, DatePicker, Radio, Checkbox } from 'antd';
import React from 'react';
import moment from 'moment';
import { queryTimes } from '@/api/personCenter/projectSpace1.4';
import { PLAN_STATUS } from '&/utils/baseMacro';
import { LoadingOutlined } from '@ant-design/icons';
import './ProjectAdjust.scss';

function ProjectAdjust(props) {
    const {
        visible,
        onCancel,
        reason = [],
        submitAdjust,
        initValues = {},
    } = props;
    const { Item } = Form;

    const [formRef] = Form.useForm();

    useEffect(() => {
        if (!visible) return;
        formRef.setFieldsValue({
            isHoliday: Number(initValues.isHoliday),
            timeAt: moment(initValues.timeAt * 1e3),
            timeEnd: moment(initValues.timeEnd * 1e3),
            reason: [],
            isOwnerAffirm: initValues.isOwnerAffirm - 0,
            days: initValues.times,
        });
    }, [visible]);

    const submit = () => {
        formRef.submit();
    };

    const [loading, setLoading] = useState(false);

    async function onFinish(fieldsValue) {
        const values = {
            ...fieldsValue,
            timeAt: fieldsValue.timeAt.format('YYYY-MM-DD'),
            timeEnd: fieldsValue.timeEnd.format('YYYY-MM-DD'),
            dop: 1,
        };
        try {
            setLoading(true);
            await submitAdjust(values);
            onCancel();
        } finally {
            setLoading(false);
        }
    }

    function onValuesChange(obj) {
        const [key] = Object.keys(obj);
        switch (key) {
            case 'days':
            case 'timeAt':
            case 'isHoliday':
                calcTimes();
                break;
            default:
                break;
        }
    }

    const [dateLoading, setDateLoading] = useState(false);

    async function calcTimes() {
        const startDate = formRef.getFieldValue('timeAt');
        const days = formRef.getFieldValue('days');
        if (!startDate || !days) return;
        const isHoliday = formRef.getFieldValue('isHoliday');
        let timeEnd;
        if (!!isHoliday) {
            setDateLoading(true);
            await queryTimes({
                days,
                timeAt: startDate.format('YYYY-MM-DD'),
                isHoliday,
            })
                .then(({ data }) => {
                    timeEnd = data.timeEnd;
                })
                .finally(() => {
                    setDateLoading(false);
                });
        } else {
            timeEnd = moment(startDate).add(days - 1, 'day');
        }
        formRef.setFieldsValue({ timeEnd: moment(timeEnd) });
    }

    const parseNumber = num => {
        if (!num) return num;
        num = num.replace(/[^0-9]/g, '');
        if (num < 1) return 1;
        if (num > 365 * 3) return 365 * 3;
        return num;
    };

    return (
        <BaseModal
            width="25.75rem"
            visible={visible}
            title={intl.get('projectSpace.adjust')}
            wrapClassName="project-adjust"
            footer={
                <Space>
                    <Button onClick={onCancel}>
                        {intl.get('base.cancel')}
                    </Button>
                    <Button loading={loading} onClick={submit} type="primary">
                        {intl.get('base.confirm')}
                    </Button>
                </Space>
            }
            onCancel={onCancel}>
            <div className="form-group save-as-template">
                <Form
                    labelCol={{ span: 6 }}
                    form={formRef}
                    onFinish={onFinish}
                    onValuesChange={onValuesChange}>
                    <Item
                        name="days"
                        label={intl.get('projectSpace.planLimit')}
                        normalize={parseNumber}
                        rules={[
                            {
                                required: true,
                            },
                        ]}>
                        <Input
                            suffix="天"
                            style={{ width: '100%' }}
                            className="unit-input"></Input>
                    </Item>
                    <Item
                        valuePropName="checked"
                        name="isHoliday"
                        normalize={value => (value ? 1 : 0)}
                        wrapperCol={{ offset: 6 }}>
                        <Checkbox>{intl.get('projectSpace.deduct')}</Checkbox>
                    </Item>
                    <Item
                        label={intl.get('projectSpace.planStart')}
                        name="timeAt"
                        rules={[
                            {
                                required: true,
                            },
                        ]}>
                        <DatePicker
                            style={{ width: '100%' }}
                            disabled={
                                initValues.status === PLAN_STATUS.UNDERWAY
                            }
                            allowClear
                            suffixIcon={<i className="icon-calendar filled" />}
                        />
                    </Item>
                    <Item
                        label={intl.get('projectSpace.planEnd')}
                        name="timeEnd"
                        className="check-item-bro">
                        <DatePicker
                            bordered={false}
                            suffixIcon={
                                dateLoading ? <LoadingOutlined /> : null
                            }
                            disabled
                        />
                    </Item>

                    <Item
                        style={{
                            margin: '0',
                        }}
                        name="reason"
                        label={intl.get('projectSpace.reason')}>
                        <Checkbox.Group style={{ width: '100%' }}>
                            {reason.map((e, idx) => {
                                return (
                                    <Checkbox key={idx} value={e}>
                                        {idx + 1}、{e}
                                    </Checkbox>
                                );
                            })}
                        </Checkbox.Group>
                    </Item>
                    <Item
                        label={intl.get('projectSpace.ownerConfirm')}
                        name="isOwnerAffirm"
                        initialValue={1}>
                        <Radio.Group>
                            <Radio value={0}>
                                {intl.get('projectSpace.notNeed')}
                            </Radio>
                            <Radio value={1}>
                                {intl.get('projectSpace.need')}
                            </Radio>
                        </Radio.Group>
                    </Item>
                </Form>
            </div>
        </BaseModal>
    );
}

export default ProjectAdjust;
